export default __webpack_public_path__ + "static/media/a018-1.f76a3fa1.svg";